import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { FaList, FaRegStickyNote } from 'react-icons/fa'
import {
  Btn,
  BtnIcon,
  CustomModal,
  CustomPanel,
  InputNumeroInteiro,
  Loading,
  PageHeader,
  TextBtn,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  atualizarSenhaDeColeta,
  getClientInvoices,
} from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { tableCellCentered } from '../../../../assets/js/styles'
import { error, verde, vinho } from '../../../../assets/js/colors'
import { renderVolumeUnitsCell } from '../ordem-coleta-volume-and-units.helper'

function NotasFiscaisCliente({ history, dispatch }) {
  // Vars
  const { delivery_id, step_id, client_id } = history.location.state

  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [invoices, setInvoices] = useState([])
  const [showModalSenha, setShowModalSenha] = useState(false)
  const [selectedInvoice, setSelectedInvoice] = useState(null)

  useEffect(() => {
    getInvoices()
  }, [])
  // Events
  const onSenhaEditar = invoice => {
    setSelectedInvoice(invoice)
    setShowModalSenha(true)
  }

  const onListIconClicked = invoice => {
    history.push('/main/ordemcoleta/nota-fiscal-cliente-items', { invoice, delivery_id })
  }

  const onModalSenhaSuccess = (invoice_id, senha) => {
    const index = invoices.findIndex(i => i.invoice_id === invoice_id)
    if (index !== -1) {
      const newInvoices = [...invoices]
      newInvoices[index].senha = senha
      setInvoices(newInvoices)
    }
    setShowModalSenha(false)
  }

  const onModalSenhaError = error => {
    dispatch(showMessageBox(null, error))
    setShowModalSenha(false)
  }

  const onModalSenhaClose = () => {
    setShowModalSenha(false)
  }

  const onNotaClick = invoice => {
    history.push('/main/ordemcoleta/nota-fiscal-cliente', {
      selectedInvoice: invoice,
      step_id,
      client_id,
    })
  }
  // Helpers
  const getInvoices = async () => {
    try {
      const fetchedInvoices = await getClientInvoices(delivery_id)
      setInvoices(fetchedInvoices)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }
  // Render
  return (
    <>
      <PageHeader>Notas Fiscais - Cliente</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onVoltar={history.goBack}
          btnLabel="Nova Nota Fiscal"
          onNovo={() => {
            history.push('/main/ordemcoleta/nota-fiscal-cliente', {
              selectedInvoice,
              step_id,
              delivery_id,
              client_id,
            })
          }}
        >
          {isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : (
            <DataTable value={invoices}>
              <Column
                field="invoice_number"
                header="Núm. Nota Fiscal"
                style={{ textAlign: 'center' }}
              />
              <Column
                field="qte_caixa"
                header="Quant. Caixas"
                style={tableCellCentered(200)}
                body={invoice => renderVolumeUnitsCell(invoice.qte_caixa_vol, invoice.qte_caixa_uni)}
              />
              <Column
                field="senha"
                header="Senha"
                style={tableCellCentered(200)}
                body={invoice => {
                  return invoice.senha ? (
                    <TextBtn onClick={() => onSenhaEditar(invoice)} color="#333333" fontSize="14px">
                      {invoice.senha}
                    </TextBtn>
                  ) : (
                    <TextBtn onClick={() => onSenhaEditar(invoice)} color={error}>
                      Incluir
                    </TextBtn>
                  )
                }}
              />
              <Column
                header="Nota"
                style={tableCellCentered(200)}
                body={invoice => {
                  return invoice.invoice_path ? (
                    <BtnIcon onClick={() => onNotaClick(invoice)}>
                      <FaRegStickyNote size={18} color={verde} />
                    </BtnIcon>
                  ) : null
                }}
              />
              <Column
                header="Itens"
                style={tableCellCentered(80)}
                body={invoice => (
                  <BtnIcon onClick={() => onListIconClicked(invoice)}>
                    {' '}
                    <FaList color={vinho} size={18} />
                  </BtnIcon>
                )}
              />
            </DataTable>
          )}
          {showModalSenha ? (
            <ModalSenha
              invoiceId={selectedInvoice.invoice_id}
              senha={selectedInvoice.senha}
              onModalClose={onModalSenhaClose}
              onError={onModalSenhaError}
              onSuccess={onModalSenhaSuccess}
            />
          ) : null}
        </CustomPanel>
      </div>
    </>
  )
}

function ModalSenha({ invoiceId, senha, onModalClose, onError, onSuccess }) {
  // Vars

  // Hooks
  const [selectedSenha, setSelectedSenha] = useState(senha)
  const [isLoading, setIsLoading] = useState(false)

  // Events
  const onModalSalvar = async () => {
    try {
      setIsLoading(true)
      if (!selectedSenha || (selectedSenha && selectedSenha.trim().length === 0))
        throw new Error('Senha Incorreta')
      await atualizarSenhaDeColeta(invoiceId, selectedSenha)
      onSuccess(invoiceId, selectedSenha)
    } catch (e) {
      onError(errorHandler(e))
    }
  }
  // Helpers

  // Render
  return (
    <CustomModal
      header={senha ? 'Altere a Senha' : 'Digite a Senha'}
      isVisible={true}
      onClose={onModalClose}
    >
      <form className="p-grid">
        <div className="p-col-12">
          <InputNumeroInteiro
            label="Senha :"
            marginTop={10}
            value={selectedSenha}
            onChange={num => setSelectedSenha(num)}
          />
        </div>
        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onModalSalvar}>
            Salvar
          </Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(withRouter(NotasFiscaisCliente))
